import { render, staticRenderFns } from "./ItemSection.vue?vue&type=template&id=4fe046b8&scoped=true&"
import script from "./ItemSection.vue?vue&type=script&lang=js&"
export * from "./ItemSection.vue?vue&type=script&lang=js&"
import style0 from "./ItemSection.vue?vue&type=style&index=0&id=4fe046b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe046b8",
  null
  
)

export default component.exports